import { Stack } from '@mui/material';
import { ScreenWrap, HeaderBreadcrumbs } from '../../components';
import UserClassificationForm from './UserClassificationForm';

export default function NewUserClassificationScreen() {
  return (
    <ScreenWrap>
      <Stack spacing={3}>
        <HeaderBreadcrumbs
          title="Create User Classification"
          items={[
            {
              name: 'Users',
              url: '/users',
            },
            {
              name: 'User Classifications',
              url: '/user-classifications',
            },
            { name: 'Create' },
          ]}
        />

        <UserClassificationForm existing={null} />
      </Stack>
    </ScreenWrap>
  );
}
